// JAZ Sales - simplified workflow strings: the Sales Employee's lead queue ("Not interested" / "Agreed"), the Customer Setup
// wizard, automatic lead distribution, the lead export and the Lead Data Entry edit window. Merged into salesTranslations.js.
export const workflowTranslations = {
  ar: {
    // ---- the lead queue ----
    nav_queue: 'طابور العملاء المحتملين',      // the menu name of a Sales Employee's landing page (not "قائمة الانتظار": that is the Wait List)
    wf_queue_title: 'عميلك المحتمل التالي',
    wf_queue_counter: 'العميل المحتمل {n} من {total}',
    wf_queue_prev: 'السابق',
    wf_queue_next: 'التالي',
    wf_queue_empty_title: 'لا يوجد عملاء محتملون بانتظارك',
    wf_queue_empty_body: 'ستظهر هنا العملاء المحتملون فور تعيينهم لك.',
    wf_queue_error: 'تعذر تحميل العميل المحتمل',
    wf_open_lead: 'صفحة العميل المحتمل',
    wf_all_my_leads: 'كل عملائي المحتملين',
    wf_assigned_on: 'مُعيّن لك منذ {date}',
    wf_decide_hint: 'بعد التواصل مع العميل، اختر النتيجة:',
    wf_not_interested: 'غير مهتم',
    wf_agreed: 'موافق / مهتم',
    wf_ni_title: 'العميل غير مهتم',
    wf_ni_hint: 'يُحفظ العميل المحتمل وسجله كاملاً ويُصنَّف كخسارة، ثم تنتقل إلى العميل التالي.',
    wf_ni_reason: 'السبب',
    wf_ni_note: 'ملاحظة',
    wf_ni_submit: 'تأكيد: غير مهتم',
    wf_toast_not_interested: 'تم تسجيل العميل كغير مهتم',

    // ---- the customer setup wizard ----
    wz_title: 'إعداد العميل: {name}',
    wz_hint: 'أنشئ شركة العميل في JAZ واشتراكها. إضافة الموظفين والمهام اختيارية.',
    wz_step_company: 'الشركة والمالك',
    wz_step_subscription: 'الاشتراك',
    wz_step_employees: 'الموظفون',
    wz_step_tasks: 'المهام',
    wz_step_review: 'المراجعة',
    wz_step_of: 'الخطوة {n} من {total}',
    wz_optional: 'اختياري',
    wz_section_company: 'معلومات الشركة',
    wz_section_owner: 'معلومات المالك',
    wz_owner_hint: 'يسجّل المالك الدخول بهذا البريد أو الهاتف وكلمة المرور.',
    wz_sub_type: 'نوع الاشتراك',
    wz_sub_trial: 'فترة تجريبية',
    wz_sub_trial_desc: '{days} أيام بالضبط ({hours} ساعة من لحظة الإنشاء)، ثم يتوقف الوصول تلقائياً حتى التجديد.',
    wz_sub_paid: 'اشتراك مدفوع',
    wz_sub_paid_desc: 'يعمل طوال مدة الخطة المختارة.',
    wz_period: 'من {start} إلى {end}',
    wz_period_trial: 'تبدأ لحظة إتمام الإعداد وتنتهي بعد {hours} ساعة بالضبط - مثلاً من {start} إلى {end}',
    wz_emp_question: 'هل تريد إضافة موظفي الشركة الآن؟',
    wz_emp_choice_now: 'إضافة الموظفين الآن',
    wz_emp_choice_later: 'سيضيفهم العميل لاحقاً',
    wz_emp_add: 'إضافة موظف',
    wz_emp_remove: 'إزالة',
    wz_emp_n: 'الموظف {n}',
    wz_emp_name: 'الاسم',
    wz_emp_email: 'البريد الإلكتروني',
    wz_emp_phone: 'الهاتف',
    wz_emp_password: 'كلمة المرور المبدئية',
    wz_emp_position: 'المسمى الوظيفي',
    wz_emp_limit: 'الخطة المختارة تسمح بـ {n} موظف كحد أقصى.',
    wz_emp_none: 'أضف موظفاً واحداً على الأقل، أو اختر أن يضيفهم العميل لاحقاً.',
    wz_task_question: 'هل تريد إنشاء مهام للشركة الآن؟',
    wz_task_choice_now: 'إنشاء المهام الآن',
    wz_task_choice_later: 'سينشئها العميل لاحقاً',
    wz_task_needs_employees: 'تُسند المهام إلى موظفي الشركة: أضف موظفاً في الخطوة السابقة، أو دع العميل ينشئ المهام لاحقاً.',
    wz_task_add: 'إضافة مهمة',
    wz_task_n: 'المهمة {n}',
    wz_task_title: 'عنوان المهمة',
    wz_task_description: 'الوصف',
    wz_task_assignee: 'الموظف المسؤول',
    wz_task_priority: 'الأولوية',
    wz_task_due: 'تاريخ الاستحقاق',
    wz_task_none: 'أضف مهمة واحدة على الأقل، أو اختر أن ينشئها العميل لاحقاً.',
    task_priority_low: 'منخفضة',
    task_priority_medium: 'متوسطة',
    task_priority_high: 'عالية',
    task_priority_critical: 'حرجة',
    wz_review_company: 'الشركة',
    wz_review_owner: 'المالك',
    wz_review_subscription: 'الاشتراك',
    wz_review_employees: 'الموظفون',
    wz_review_tasks: 'المهام',
    wz_review_none_employees: 'لا موظفين الآن - سيضيفهم العميل',
    wz_review_none_tasks: 'لا مهام الآن - سينشئها العميل',
    wz_review_marks_won: 'سيُصنَّف العميل المحتمل «تم الفوز» عند الإنهاء.',
    wz_back: 'رجوع',
    wz_next: 'التالي',
    wz_finish: 'إنهاء الإعداد',
    wz_loading: 'جارٍ التحضير...',
    wz_toast_done: 'تم إعداد العميل وإنشاء شركته في JAZ',
    wz_toast_already: 'تم إعداد هذا العميل من قبل',
    wz_blocker_lead_lost: 'هذا العميل المحتمل مصنّف كخسارة. أعد فتحه أولاً.',
    wz_blocker_lead_unassigned: 'عيّن العميل المحتمل لموظف مبيعات أولاً.',
    wz_problem_employee_email_registered: 'هذا البريد مسجّل لحساب في JAZ.',
    wz_problem_employee_phone_registered: 'هذا الهاتف مسجّل لحساب في JAZ.',
    wz_problem_employee_email_repeated: 'هذا البريد مستخدم مرتين في هذا الإعداد.',
    wz_problem_employee_phone_repeated: 'هذا الهاتف مستخدم مرتين في هذا الإعداد.',
    wz_problem_employee_phone_invalid: 'رقم الهاتف غير صالح.',
    wz_problem_employee_password_weak: 'كلمة المرور ضعيفة.',
    wz_problem_task_assignee_invalid: 'اختر موظفاً من الموظفين المضافين.',
    wz_problem_task_due_date_past: 'لا يمكن أن يكون تاريخ الاستحقاق في الماضي.',
    setup_panel_ready_open: 'هل وافق العميل؟ أكمل إعداد العميل مباشرة، أو سجّله كغير مهتم.',
    setup_panel_ready_won: 'هذا العميل المحتمل فائز. أكمل إعداد العميل لإنشاء شركته في JAZ.',
    setup_action: 'إعداد العميل',
    sub_type_trial: 'تجريبي',
    sub_type_paid: 'مدفوع',
    cust_subscription_type: 'نوع الاشتراك',

    // ---- distribution ----
    dist_button_on: 'التوزيع التلقائي: مفعّل',
    dist_button_off: 'التوزيع التلقائي: متوقف',
    dist_title: 'توزيع العملاء المحتملين',
    dist_hint: 'عند التفعيل، يُعيَّن كل عميل محتمل جديد لم يُحدَّد له موظف إلى موظف المبيعات التالي بالدور.',
    dist_enabled: 'التوزيع التلقائي للعملاء المحتملين',
    dist_mode: 'طريقة التوزيع',
    dist_mode_equal: 'توزيع متساوٍ',
    dist_mode_equal_desc: 'عميل محتمل واحد لكل موظف بالدور، بترتيب ثابت.',
    dist_rotation: 'موظفو المبيعات المشمولون',
    dist_rotation_hint: 'الموظفون الموقوفون أو المسحوبة أدوارهم لا يستلمون عملاء محتملين.',
    dist_next: 'التالي بالدور',
    dist_open: '{n} مفتوح',
    dist_nobody: 'لا يوجد موظفو مبيعات نشطون. سيبقى العملاء المحتملون الجدد بلا تعيين.',
    dist_manual_note: 'يبقى التعيين وإعادة التعيين اليدوي متاحاً دائماً.',
    dist_save: 'حفظ',
    dist_saved: 'تم حفظ إعدادات التوزيع',
    dist_updated_by: 'آخر تعديل: {name} · {date}',
    dist_load_error: 'تعذر تحميل إعدادات التوزيع',

    // ---- export ----
    exp_excel: 'تصدير Excel',
    exp_pdf: 'تصدير PDF',
    exp_working: 'جارٍ التصدير...',
    exp_done: 'تم تصدير {n} عميل محتمل',
    exp_done_generic: 'تم التصدير',
    exp_hint: 'يشمل التصدير كل العملاء المحتملين المطابقين للبحث والتصفية الحالية، وليس هذه الصفحة فقط.',

    // ---- the Lead Data Entry edit window ----
    lead_edit_locked_note: 'يمكنك تعديل أو حذف آخر 10 عملاء محتملين أضفتهم فقط، وما دام العميل المحتمل غير معيَّن لموظف مبيعات. تعديل هذا العميل المحتمل متاح لمدير المبيعات.',

    // ---- errors ----
    err_lead_edit_window: 'يمكنك تعديل أو حذف آخر 10 عملاء محتملين أضفتهم فقط، وما دام العميل المحتمل غير معيَّن لموظف مبيعات. تواصل مع مدير المبيعات.',
    err_won_requires_customer_setup: 'يُعتمد العميل المحتمل عبر «إعداد العميل» (موافق / مهتم) الذي ينشئ العميل والشركة أيضاً. استخدمه بدلاً من نقل العميل المحتمل إلى «تم الفوز».',
    err_conversion_retired: 'تم إيقاف التحويل القديم للعميل المحتمل. استخدم «إعداد العميل» بدلاً منه.',
    err_lead_lost: 'هذا العميل المحتمل مصنّف كخسارة. أعد فتحه أولاً.',
    err_lead_unassigned: 'عيّن العميل المحتمل لموظف مبيعات أولاً.',
    err_employees_invalid: 'لا يمكن إضافة بعض الموظفين. صحّح الحقول المحددة أو أضفهم لاحقاً.',
    err_tasks_invalid: 'لا يمكن إنشاء بعض المهام. صحّح الحقول المحددة أو أنشئها لاحقاً.',
    err_tasks_need_employees: 'أضف موظفاً واحداً على الأقل لإسناد المهام إليه، أو دع العميل ينشئ المهام لاحقاً.',
    err_employees_over_plan_limit: 'عدد الموظفين أكبر من الحد المسموح في الخطة المختارة.',
    err_owner_password_weak: 'كلمة مرور المالك ضعيفة.',
    err_plan_not_available: 'خطة الاشتراك المختارة غير متاحة.',
    err_export_too_large: 'عدد العملاء المحتملين المطابقين كبير جداً للتصدير. ضيّق عوامل التصفية.',
  },
  en: {
    nav_queue: 'Lead Queue',
    wf_queue_title: 'Your next lead',
    wf_queue_counter: 'Lead {n} of {total}',
    wf_queue_prev: 'Previous',
    wf_queue_next: 'Next',
    wf_queue_empty_title: 'No leads waiting for you',
    wf_queue_empty_body: 'Leads appear here as soon as they are assigned to you.',
    wf_queue_error: 'Could not load your lead',
    wf_open_lead: 'Lead page',
    wf_all_my_leads: 'All my leads',
    wf_assigned_on: 'Assigned to you {date}',
    wf_decide_hint: 'After talking to the customer, choose the outcome:',
    wf_not_interested: 'Not interested',
    wf_agreed: 'Agreed / Interested',
    wf_ni_title: 'Customer not interested',
    wf_ni_hint: 'The lead and its whole history are kept and it is marked as lost. You then move on to the next lead.',
    wf_ni_reason: 'Reason',
    wf_ni_note: 'Note',
    wf_ni_submit: 'Confirm: not interested',
    wf_toast_not_interested: 'Marked as not interested',

    wz_title: 'Customer setup: {name}',
    wz_hint: "Create the customer's JAZ company and subscription. Adding employees and tasks is optional.",
    wz_step_company: 'Company & owner',
    wz_step_subscription: 'Subscription',
    wz_step_employees: 'Employees',
    wz_step_tasks: 'Tasks',
    wz_step_review: 'Review',
    wz_step_of: 'Step {n} of {total}',
    wz_optional: 'optional',
    wz_section_company: 'Company information',
    wz_section_owner: 'Owner information',
    wz_owner_hint: 'The owner signs in with this email or phone and the password.',
    wz_sub_type: 'Subscription type',
    wz_sub_trial: 'Trial',
    wz_sub_trial_desc: 'Exactly {days} days ({hours} hours from the moment it is created), then access stops automatically until renewed.',
    wz_sub_paid: 'Paid subscription',
    wz_sub_paid_desc: "Runs for the chosen plan's full duration.",
    wz_period: 'From {start} to {end}',
    wz_period_trial: 'Starts when you complete the setup and ends exactly {hours} hours later - e.g. {start} to {end}',
    wz_emp_question: "Add the company's employees now?",
    wz_emp_choice_now: 'Add employees now',
    wz_emp_choice_later: 'The customer will add them later',
    wz_emp_add: 'Add employee',
    wz_emp_remove: 'Remove',
    wz_emp_n: 'Employee {n}',
    wz_emp_name: 'Name',
    wz_emp_email: 'Email',
    wz_emp_phone: 'Phone',
    wz_emp_password: 'Initial password',
    wz_emp_position: 'Position',
    wz_emp_limit: 'The chosen plan allows up to {n} employees.',
    wz_emp_none: 'Add at least one employee, or choose to let the customer add them later.',
    wz_task_question: 'Create tasks for the company now?',
    wz_task_choice_now: 'Create tasks now',
    wz_task_choice_later: 'The customer will create them later',
    wz_task_needs_employees: "Tasks are given to the company's employees: add an employee in the previous step, or let the customer create tasks later.",
    wz_task_add: 'Add task',
    wz_task_n: 'Task {n}',
    wz_task_title: 'Task title',
    wz_task_description: 'Description',
    wz_task_assignee: 'Assigned employee',
    wz_task_priority: 'Priority',
    wz_task_due: 'Due date',
    wz_task_none: 'Add at least one task, or choose to let the customer create them later.',
    task_priority_low: 'Low',
    task_priority_medium: 'Medium',
    task_priority_high: 'High',
    task_priority_critical: 'Critical',
    wz_review_company: 'Company',
    wz_review_owner: 'Owner',
    wz_review_subscription: 'Subscription',
    wz_review_employees: 'Employees',
    wz_review_tasks: 'Tasks',
    wz_review_none_employees: 'No employees now - the customer will add them',
    wz_review_none_tasks: 'No tasks now - the customer will create them',
    wz_review_marks_won: 'The lead will be marked as won when you finish.',
    wz_back: 'Back',
    wz_next: 'Next',
    wz_finish: 'Complete setup',
    wz_loading: 'Preparing...',
    wz_toast_done: 'Customer set up and JAZ company created',
    wz_toast_already: 'This customer was already set up',
    wz_blocker_lead_lost: 'This lead is marked as lost. Reopen it first.',
    wz_blocker_lead_unassigned: 'Assign the lead to a Sales Employee first.',
    wz_problem_employee_email_registered: 'This email is already registered to a JAZ account.',
    wz_problem_employee_phone_registered: 'This phone number is already registered to a JAZ account.',
    wz_problem_employee_email_repeated: 'This email is used twice in this setup.',
    wz_problem_employee_phone_repeated: 'This phone number is used twice in this setup.',
    wz_problem_employee_phone_invalid: 'Invalid phone number.',
    wz_problem_employee_password_weak: 'The password is too weak.',
    wz_problem_task_assignee_invalid: 'Choose one of the employees added here.',
    wz_problem_task_due_date_past: 'The due date cannot be in the past.',
    setup_panel_ready_open: 'Did the customer agree? Complete the customer setup right away, or record them as not interested.',
    setup_panel_ready_won: 'This lead is won. Complete the customer setup to create its JAZ company.',
    setup_action: 'Set up customer',
    sub_type_trial: 'Trial',
    sub_type_paid: 'Paid',
    cust_subscription_type: 'Subscription',

    dist_button_on: 'Auto distribution: On',
    dist_button_off: 'Auto distribution: Off',
    dist_title: 'Lead distribution',
    dist_hint: 'When on, every new lead created without a chosen owner goes to the next Sales Employee in turn.',
    dist_enabled: 'Automatic lead distribution',
    dist_mode: 'Distribution method',
    dist_mode_equal: 'Equal distribution',
    dist_mode_equal_desc: 'One lead per employee in turn, in a fixed order.',
    dist_rotation: 'Sales Employees in the rotation',
    dist_rotation_hint: 'Deactivated employees and revoked roles never receive leads.',
    dist_next: 'Next in turn',
    dist_open: '{n} open',
    dist_nobody: 'No active Sales Employees. New leads stay unassigned.',
    dist_manual_note: 'Assigning and reassigning by hand always stays available.',
    dist_save: 'Save',
    dist_saved: 'Distribution settings saved',
    dist_updated_by: 'Last changed by {name} · {date}',
    dist_load_error: 'Could not load the distribution settings',

    exp_excel: 'Export Excel',
    exp_pdf: 'Export PDF',
    exp_working: 'Exporting...',
    exp_done: 'Exported {n} leads',
    exp_done_generic: 'Export ready',
    exp_hint: 'Exports every lead matching the current search and filters, not just this page.',

    lead_edit_locked_note: 'You can edit or delete only the 10 most recent leads you created, and only while they are unassigned. A Sales Manager can change this one.',

    err_lead_edit_window: 'You can edit or delete only the 10 most recent leads you created, and only while they are unassigned. Ask a Sales Manager.',
    err_won_requires_customer_setup: 'A lead is won through the Customer Setup ("Agreed / Interested"), which also creates the customer. Use it instead of moving the lead to Won.',
    err_conversion_retired: 'The old lead conversion has been retired. Use the Customer Setup instead.',
    err_lead_lost: 'This lead is marked as lost. Reopen it first.',
    err_lead_unassigned: 'Assign the lead to a Sales Employee first.',
    err_employees_invalid: 'Some employees cannot be added. Correct the highlighted fields, or add them later.',
    err_tasks_invalid: 'Some tasks cannot be created. Correct the highlighted fields, or create them later.',
    err_tasks_need_employees: 'Add at least one employee to give tasks to, or let the customer create tasks later.',
    err_employees_over_plan_limit: 'More employees than the chosen plan allows.',
    err_owner_password_weak: "The owner's password is too weak.",
    err_plan_not_available: 'The chosen subscription plan is not available.',
    err_export_too_large: 'Too many leads match to export at once. Narrow the filters.',
  },
};
